import React, { Component, useEffect, useState } from "react";
import Form from "../../../comman/form";
import geo, { getStateList } from "../../../services/geoService";
import auth from "../../../services/authService";
import config from "../../../config.json";
import { Link } from "react-router-dom";
import Joi from "joi-browser";
import Swal from "sweetalert2";
import moment from "moment";
import Select from "../../../comman/select";
import useForm from "../../../app/hooks/useForm";
import useControls from "../../../app/hooks/useControls";
import { getApplicationData } from "../../../app/store/application";
import { candidateUpdated, getCandidateUpatedStatus, updateNewCandidate } from "../../../app/store/candidate";
import { addNewRates, getRateAddedStatus, rateRefresh, updateRate } from "../../../app/store/rates";
import { useDispatch, useSelector } from "react-redux";
import { getCurrentUser } from "../../../app/store/auth";
import { addNewDuration, getDurationAddedStatus, getStateAdminData, stateadmindataUpdated } from "../../../app/store/duration";
import { getAlert } from "../../../services/appAlerts";

const Agency = (props) => {

  const { candidateObj, actType, handleNextTab, updateSelectedObject, rateHistory } = props;

  const schema = {
    State: Joi.string().required().label("State"),
    AgencyName: Joi.string().required().label("Agency Name"),
    PositionTitle: Joi.string().required().label("Position Title"),
    StartDate: Joi.string().required().label("Start Date"),
    EngagementDuration: Joi.number()
      //.required()
      .min(1)
      .max(120)
      .options({
        language: {
          string: {
            min: `should be minimum ${1} and maximum ${120} numeric digits only.`,
            max: `should be minimum ${1} and maximum ${120} numeric digits only.`,
          },
        },
      })
      .label("Engagement Duration (Month)"),
    Engagement_Day: Joi.number()
      //.required()
      .min(0)
      .max(29)
      .options({
        language: {
          string: {
            min: `should be minimum ${1} and maximum ${29} numeric digits only.`,
            max: `should be minimum ${1} and maximum ${29} numeric digits only.`,
          },
        },
      })
      .label("Engagement Duration (Day)"),
    RatePayableIpcs: Joi.alternatives()
      .try(
        Joi.string(),
        Joi.number()
      )
      .required()
      .label("Rate/Hour-Received By IPCS $"),

    PositionID: Joi.string().required().label("Position ID"),
    PositionLocation: Joi.string().required().label("Position Location"),
  };

  const [stateList, setStateList] = useState([]);
  const [aworkfinityApp, setAworkfinityApp] = useState(null);
  const [updatedStateData, setUpdatedStateData] = useState({});
  const [saveBtnType, setSaveBtnType] = useState("");
  const [compName, setCompName] = useState("");

  const durationAddedStatusSelector = useSelector(getDurationAddedStatus);
  const candidateUpatedStatusSelector = useSelector(getCandidateUpatedStatus);
  const rateAddedStatusSelector = useSelector(getRateAddedStatus)

  const dispatch = useDispatch();
  const currentUser = getCurrentUser();

  useEffect(() => {
    getUsStates();
  }, []);

  const getUsStates = async () => {
    const dt = await getStateList();
    setStateList([{ countryGeonameId: 0, geonameId: 0, name: "Not Applicable" }, ...dt]);
  }

  useEffect(() => {
    if (candidateObj?.performerData) {
      const obj = getApplicationData(candidateObj.performerData);
      if (obj?.aWorkfinityApp) {
        setAworkfinityApp(obj.aWorkfinityApp);
        const appName = Object.keys(obj.aWorkfinityApp)[1];
        const aWorkfinityAppEntity = obj.aWorkfinityApp[appName];
        const agencyData = aWorkfinityAppEntity["projectengagement"];
        const data = {};
        if (agencyData) {
          Object.keys(agencyData).forEach(function (keyValue1) {
            if (keyValue1 !== "EntityId") {
              var item = agencyData[keyValue1];
              if (!Array.isArray(item)) data[keyValue1.replace("@", "")] = item;
            }
          });
          // if (data["State"] === 'Not Applicable') {
          //   data["RatePayableIpcs"] = null
          // } else {
          //   const latestRate = rateHistory[rateHistory.length - 1]?.agencyRate;
          //   data["RatePayableIpcs"] = latestRate != null ? latestRate : 0;
          // }
          // data["RatePayableIpcs"] = candidateObj?.rates?.agencyRate
          const latestRate = rateHistory[rateHistory.length - 1]?.agencyRate;
          data["RatePayableIpcs"] = latestRate != null ? latestRate : 0;
          setStateData(data);
          setUpdatedStateData(data);
        }
      }
    }
    else {
      setStateData({});
      setAworkfinityApp(null);
    }

  }, [candidateObj, rateHistory]);

  const doSubmit = (btnType) => {
    if (!candidateObj?.performerid) {
      getAlert("", "Save candidate details before updating agency details", "warning");
      return;
    }

    setSaveBtnType(btnType);
    const NewAWorkfinityApp = { ...aworkfinityApp };
    const appName = Object.keys(NewAWorkfinityApp)[1];
    const aWorkfinityAppEntity = NewAWorkfinityApp[appName];

    const projectengagement = {};
    Object.keys(stateData).forEach(function (keyValue) {
      projectengagement["@" + keyValue] = stateData[keyValue];
    });

    aWorkfinityAppEntity["projectengagement"] = projectengagement;
    NewAWorkfinityApp[appName] = aWorkfinityAppEntity;
    setAworkfinityApp(NewAWorkfinityApp);
    const formData = new FormData();
    formData.append("appEntity", JSON.stringify(NewAWorkfinityApp));
    formData.append("recruiter", "");
    formData.append("subcontractor", "");
    formData.append("perfId", candidateObj.performerid);
    dispatch(stateadmindataUpdated({
      RatePayableIpcs: stateData["RatePayableIpcs"] || 0,
      State_Admin_Fee: stateData["State_Admin_Fee"] || 0,
      State_Admin_Fee_Amount: stateData["State_Admin_Fee_Amount"] || 0,
    }))
    dispatch(updateNewCandidate(formData));

    // if (stateData["State"] !== "Not Applicable") {
    //   handleSaveRates();
    // }
    //handleSaveRates();
    handleSaveDuration();
    // if (actType === "edit") {
    //   updateSelectedObject(candidateObj.performerid, aworkfinityApp);
    // } else {
    //   updateSelectedObject(candidateObj.performerid);
    // }

    // updateSelectedObject(candidateObj.performerid, aworkfinityApp);
    //handleNextTab(saveBtnType);
    setCompName("agency");
  }

  const handleUpdaterates = () => {
    const data = { ...rateHistory[rateHistory.length - 1] };
    const rateObj = {
      performerId: candidateObj.performerid,
      id: data.id,
      addedBy: currentUser.id,
      notes: data["notes"],
      subcontractorRate: data["subcontractorRate"] || 0,
      recruiterRate: data["recruiterRate"] || 0,
      candidateRate: data["candidateRate"] || 0,
      agencyRate: stateData["RatePayableIpcs"] || 0,
      subcontractorTechFee: data["subcontractorTechFee"] || 0,
      candidateTechFee: data["candidateTechFee"] || 0,
      recruiterTechFee: data["recruiterTechFee"] || 0,
      agencyTechFee: data["agencyTechFee"] || 0,
      candidateEffectiveDate: data["candidateEffectiveDate"] || new Date().toISOString(),
      agencyEffectiveDate: data["agencyEffectiveDate"] || new Date().toISOString(),
      subcontractorEffectiveDate: data["subcontractorEffectiveDate"] || new Date().toISOString(),
      recruiterEffectiveDate: data["recruiterEffectiveDate"] || new Date().toISOString(),
    };
    dispatch(addNewRates(rateObj))
  }

  useEffect(() => {
    if (rateAddedStatusSelector) {
      dispatch(rateRefresh())
    }
  }, [rateAddedStatusSelector])

  const handleSaveRates = () => {
    const frmData = new FormData();
    frmData.append("id", candidateObj.performerid);
    frmData.append("type", "agency");
    frmData.append("date", stateData["StartDate"] || new Date().toISOString());
    frmData.append("agencyRate", stateData["RatePayableIpcs"] || 0);
    dispatch(updateRate(frmData));
  };

  const handleSaveDuration = () => {
    const frmObj = {
      performerId: candidateObj.performerid,
      addedBy: currentUser.id,
      duration: stateData["EngagementDuration"],
      durationState: true,
      endDate: new Date(stateData["EndDate"]),
      notes: "Default",
      startDate: stateData["StartDate"],
      fixedHours: stateData["Fixed_Hours"],
      adminFeeAmount: stateData["State_Admin_Fee_Amount"],
      adminFeePercentage: stateData["State_Admin_Fee"],
    };
    dispatch(addNewDuration(frmObj));
  };

  useEffect(() => {
    if (candidateUpatedStatusSelector && compName === "agency") {
      setCompName("");
      if (actType === "edit") {
        getAlert("", "Updated Successfully", "success");
        handleUpdaterates()
      }
      else {
        getAlert("", "Saved Successfully", "success");
      }

      updateSelectedObject(candidateObj.performerid, aworkfinityApp);
      handleSaveRates();
      handleNextTab(saveBtnType);
      dispatch(candidateUpdated(null));
    }
  }, [candidateUpatedStatusSelector])


  const { validate, handleChange, stateData, setStateData,
    stateErrors, setStateErrors, handleSubmit2 } = useForm(schema, doSubmit);

  const { renderSelect, renderInput, renderTextArea } = useControls(stateData, stateErrors, handleChange, schema);

  const handleAgencyRateChange = ({ target }) => {
    const updData = { ...stateData };
    updData[target.name] = target.value;
    setStateData(updData);
  }

  const handleAdminFeePerChange = ({ target }) => {
    let rateAmt = parseFloat(stateData["RatePayableIpcs"]);
    const techFee = parseFloat(stateData["Tech_Fee"]);
    if (techFee > 0)
      rateAmt -= techFee;

    if (parseInt(target.value) >= 100) {
      getAlert("Warning", "Should be minimum 1 and maximum 99 numeric digits only.", "warning");
      return;
    }
    const updData = { ...stateData };
    updData[target.name] = target.value;
    updData["State_Admin_Fee_Amount"] = "0";
    setStateData(updData);
  }

  const handleAdminFeeChange = ({ target }) => {
    let rateAmt = parseFloat(stateData["RatePayableIpcs"]);
    const techFee = parseFloat(stateData["Tech_Fee"]);
    if (techFee > 0)
      rateAmt -= techFee;

    if (parseFloat(target.value) >= rateAmt) {
      getAlert("Warning", `Should be less then ${rateAmt} received by agency.`, "warning");
      return;
    }
    const updData = { ...stateData };
    updData[target.name] = target.value;
    updData["State_Admin_Fee"] = "0";
    setStateData(updData);
  }

  const handleTechFeeChange = ({ target }) => {
    let rateAmt = parseFloat(stateData["RatePayableIpcs"]);
    const adminFee = parseFloat(stateData["State_Admin_Fee_Amount"]);
    const adminFeePrc = parseInt(stateData["State_Admin_Fee"]);

    if (adminFee > 0)
      rateAmt -= adminFee;

    if (adminFeePrc > 0)
      rateAmt -= (rateAmt * adminFeePrc / 100);

    if (parseFloat(target.value) >= rateAmt) {
      getAlert("Warning", `Should be less then ${rateAmt} received by agency.`, "warning");
      return;
    }
    const updData = { ...stateData };
    updData[target.name] = target.value;
    setStateData(updData);
  }

  useEffect(() => {
    if (!stateData?.StartDate || !stateData?.EngagementDuration) return;

    const dt = new Date(stateData.StartDate);
    const num = parseInt(stateData.EngagementDuration);
    const numDay = parseInt(stateData.Engagement_Day);
    if (!(num < 999)) return;

    dt.setDate(dt.getDate() + 1);
    dt.setMonth(dt.getMonth() + num);
    dt.setDate(dt.getDate() - 1);
    if (numDay < 30 && numDay > 0) dt.setDate(dt.getDate() + numDay);

    const dy = dt.getFullYear();
    let dm = dt.getMonth() + 1;
    let dd = dt.getDate();
    if (dm < 10) dm = "0" + dm;
    if (dd < 10) dd = "0" + dd;
    const endDate = dy + "-" + dm + "-" + dd;

    if (stateData.EndDate !== endDate) {
      setStateData({ ...stateData, EndDate: endDate });
    }
  }, [stateData, setStateData]);

  return (
    <div className="wf-agency-tab-container col-md-12">
      <style>{`
        /* Premium custom styles for Agency Tab matching AddWorkflowPerformer */
        .wf-agency-tab-container .form-group label {
          font-size: 11px !important; font-weight: 700 !important; color: #64748b !important;
          text-transform: uppercase !important; letter-spacing: 0.7px !important;
          margin-bottom: 6px !important; display: flex !important;
          align-items: center !important; gap: 5px !important;
        }

        .wf-agency-tab-container .form-group { margin-bottom: 16px; }
        .wf-agency-tab-container .wf-input-wrap { position: relative; }
        .wf-agency-tab-container .wf-input-icon {
          position: absolute; left: 12px; top: 50%; transform: translateY(-50%);
          color: #94a3b8; font-size: 13px; pointer-events: none;
          transition: color 0.2s ease; z-index: 1;
        }
        .wf-agency-tab-container .wf-input-wrap:focus-within .wf-input-icon { color: #2563eb; }

        .wf-agency-tab-container .form-control {
          border-radius: 9px !important;
          border: 1.5px solid #e2e8f0 !important;
          padding: 8px 13px !important;
          font-size: 13px !important;
          color: #1e293b !important;
          background: #ffffff !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.03) !important;
          width: 100% !important;
          height: auto !important;
        }
        .wf-agency-tab-container .form-control.wf-input-withicon {
          padding-left: 35px !important;
        }
        .wf-agency-tab-container .form-control:focus {
          border-color: #2563eb !important;
          box-shadow: 0 0 0 4px rgba(37, 99, 235, 0.1), 0 2px 6px -1px rgba(37, 99, 235, 0.08) !important;
          outline: none !important; background: #fafbff !important;
        }
        .wf-agency-tab-container select.form-control {
          appearance: none !important; -webkit-appearance: none !important;
          background: #ffffff url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6'%3E%3Cpath d='M0 0l5 6 5-6z' fill='%2394a3b8'/%3E%3C/svg%3E") no-repeat right 12px center !important;
          padding-right: 32px !important;
        }

        .wf-agency-tab-container .btn-primary-custom {
          background: #2563eb !important;
          border: 1px solid #2563eb !important;
          color: #ffffff !important;
          font-weight: 700 !important;
          font-size: 13.5px !important;
          padding: 8px 24px !important;
          border-radius: 8px !important;
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
          box-shadow: 0 4px 6px -1px rgba(37, 99, 235, 0.12), 0 2px 4px -1px rgba(37, 99, 235, 0.06) !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 8px !important;
        }
        .wf-agency-tab-container .btn-primary-custom:hover:not(:disabled) {
          background: #1d4ed8 !important;
          border-color: #1d4ed8 !important;
          transform: translateY(-1px) !important;
          box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.18), 0 4px 6px -2px rgba(37, 99, 235, 0.08) !important;
        }
        .wf-agency-tab-container .btn-primary-custom:disabled {
          background: #e2e8f0 !important;
          border-color: #cbd5e1 !important;
          color: #94a3b8 !important;
          cursor: not-allowed !important;
          box-shadow: none !important;
        }

        .wf-agency-tab-container .wf-section-title {
          font-size: 13px !important;
          font-weight: 700 !important;
          color: #1e293b !important;
          padding: 8px 12px !important;
          background: #f1f5f9 !important;
          border-left: 4px solid #2563eb !important;
          border-radius: 0 6px 6px 0 !important;
          display: flex !important;
          align-items: center !important;
          gap: 8px !important;
          width: 100% !important;
          margin-top: 15px !important;
          margin-bottom: 15px !important;
        }
      `}</style>

      <div className="row">
        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-building" /> Agency & Project Information
          </h5>
        </div>
        <div className="col-md-6">
          {renderInput("AgencyName", "Agency Name", "text", null, false, 0, undefined, "fa-building-o")}
        </div>
        <div className="col-md-6">
          {renderSelect("State", "State", stateList, "name", "name", "fa-map-marker")}
        </div>

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-briefcase" /> Position Details
          </h5>
        </div>
        <div className="col-md-6">
          {renderInput("PositionTitle", "Position Title", "text", null, false, 0, undefined, "fa-id-card-o")}
        </div>
        <div className="col-md-6">
          {renderInput("PositionID", "Position ID", "text", null, false, 0, undefined, "fa-hashtag")}
        </div>
        <div className="col-md-12">
          {renderInput("PositionLocation", "Position Location", "text", null, false, 0, undefined, "fa-map-pin")}
        </div>

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-calendar-check-o" /> Engagement Terms & Rates
          </h5>
        </div>
        <div className="col-md-3">
          {renderInput("StartDate", "Start Date", "date", null, false, 0, undefined, "fa-calendar")}
        </div>
        <div className="col-md-3">
          {renderInput(
            "EngagementDuration",
            "Duration (Months)",
            "number",
            null,
            false,
            0,
            undefined,
            "fa-clock-o"
          )}
        </div>
        <div className="col-md-2">
          {renderInput("Engagement_Day", "Days", "number", null, false, 0, undefined, "fa-sun-o")}
        </div>
        <div className="col-md-1 d-flex align-items-center justify-content-center">
          <label htmlFor="" className="form-control-label">
            OR
          </label>
        </div>
        <div className="col-md-3">
          <fieldset disabled={true}>
            {renderInput("EndDate", "End Date", "date", null, false, 0, undefined, "fa-calendar-times-o")}
          </fieldset>
        </div>

        <div className="col-md-5">
          {renderInput("RatePayableIpcs", "Rate/Hour (IPCS) $", "number", null, false, 0, undefined, "fa-money")}
        </div>

        <div className="col-md-3 form-group">
          {renderInput("State_Admin_Fee", "State Admin Fee %", "number", null, !(parseInt(stateData["RatePayableIpcs"]) > 0), 0, undefined, "fa-percent")}
        </div>
        <div className="col-md-1 d-flex align-items-center justify-content-center">
          <label htmlFor="" className="form-control-label">
            OR
          </label>
        </div>
        <div className="col-md-3">
          {renderInput("State_Admin_Fee_Amount", "Admin Fee $/Hr", "number", null, !(parseInt(stateData["RatePayableIpcs"]) > 0), 0, undefined, "fa-dollar")}
        </div>
        <div className="col-md-6">
          {renderInput("Fixed_Hours", "Fixed Hours", "number", null, false, 0, undefined, "fa-hourglass-half")}
        </div>

        <div className="col-md-12">
          {renderTextArea("ProjectDescription", "Project Description", "fa-file-text-o")}
        </div>

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-user-circle-o" /> Agency Primary Contact
          </h5>
        </div>

        <div className="col-md-6">
          {renderInput("AgencyContact", "Name", "text", null, false, 0, undefined, "fa-user")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyTitle", "Title", "text", null, false, 0, undefined, "fa-vcard-o")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyEmail", "Email", "text", null, false, 0, undefined, "fa-envelope-o")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyPhone", "Phone No.", "phone", null, false, 0, undefined, "fa-phone")}
        </div>

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-user-circle-o" /> Agency Secondary Contact
          </h5>
        </div>
        <div className="col-md-6">
          {renderInput("AgencyContactName2", "Name", "text", null, false, 0, undefined, "fa-user")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyContactTitle2", "Title", "text", null, false, 0, undefined, "fa-vcard-o")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyContactEmail2", "Email", "text", null, false, 0, undefined, "fa-envelope-o")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyContactPhone2", "Phone No.", "phone", null, false, 0, undefined, "fa-phone")}
        </div>

        <div className="col-md-12">
          <h5 className="wf-section-title">
            <i className="fa fa-user-circle-o" /> Agency Additional Contact
          </h5>
        </div>
        <div className="col-md-6">
          {renderInput("AgencyContactName3", "Name", "text", null, false, 0, undefined, "fa-user")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyContactTitle3", "Title", "text", null, false, 0, undefined, "fa-vcard-o")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyContactEmail3", "Email", "text", null, false, 0, undefined, "fa-envelope-o")}
        </div>
        <div className="col-md-6">
          {renderInput("AgencyContactPhone3", "Phone No.", "phone", null, false, 0, undefined, "fa-phone")}
        </div>

        <div className="col-md-12 text-center form-group mt-4 mb-4">
          <button
            type="button"
            className="btn-primary-custom"
            disabled={stateData["State"] === "Not Applicable" ? false : validate()}
            onClick={() => handleSubmit2("save")}
          >
            <i className="fa fa-check" /> Save and Update Agency Details
          </button>
          {actType !== "edit" && (
            <button
              type="button"
              className="btn-primary-custom ml-2"
              onClick={() => handleNextTab("next")}
            >
              <i className="fa fa-arrow-right" /> Next
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default Agency;
